module.exports = __webpack_public_path__ + "media/images/pages/fcr-case/case-5-bd2b0c3f7a2e2e08b14c9d97a007863a.png";